import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { TRANSPARENT_COLOR } from '@src/styles/color';

export const StyledCircularProcess = styled(Box)`
  position: relative;
  .circular-background {
    color: ${TRANSPARENT_COLOR.secondary};
  }

  .value-progress {
    font-size: ${(props) => (props.textSize ? props.textSize : 16)}px;
    position: absolute;
    left: 50%;
    top: 47%; // Hotfix for centering text in the circle
    transform: translate(-50%, -50%);
    color: ${(props) => (props.textColor ? props.textColor : 'inherit')};
  }
`;
